import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Clickable, { ClickEventListener } from '@philips-emr/tws-core/lib/component/types/clickable';

class TabItemAPI extends ComponentAPI implements Clickable {

  /** @event */
  @AwesomeEvent
  onClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onDoubleClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onContextMenuClick = new ClickEventListener();

  getBadge(): string {
    return this.state.badge;
  }

  setBadge(badge: string): void {
    this.setState({ badge });
  }

  getLabel(): string {
    return this.state.label;
  }

  setLabel(label: string): void {
    this.setState({ label });
  }

  isUppercase(): boolean {
    return this.state.uppercase;
  }

  setUppercase(uppercase: boolean): void {
    this.setState({ uppercase });
  }

}

export default TabItemAPI;
